<template>
  <div>
    <fieldset>
      <div class="row">
        <legend>RX Information</legend>
        <p v-if="sampleobject.programId == 'TROPP'" class="small-text"> Please note: Xtractive Polarized Gray is only available on Varilux Comfort DRx.<br></p>
      </div>
      <div class="row" style="display: flex; flex-wrap: wrap;">
        <div class="columns small-12 medium-4 text-left lp">
          <p class="small-text">{{ choices.lensDesignLabel }}:
            <br>
            <strong>{{ chosenDesign }}</strong>
          </p>
        </div>
        <div class="columns small-12 medium-8 text-left lp" style="display: flex; flex-wrap: wrap;">
          <div v-if="chosenMaterial" class="columns small-12 medium-4 text-left lp">
            <p class="small-text">{{ choices.lensMaterialLabel }}:
              <br>
              <strong>{{ chosenMaterial }}</strong>
            </p>
          </div>
          <div v-if="chosenPhotochromic" class="columns small-12 medium-4 text-left lp">
            <p class="small-text">{{ choices.lensPhotochromicLabel }}:
              <br>
              <strong>{{ chosenPhotochromic }}</strong>
            </p>
          </div>
          <div v-if="chosenTreatment" class="columns small-12 medium-4 text-left lp">
            <p class="small-text">{{ choices.lensTreatmentLabel }}:
              <br>
              <strong>{{ chosenTreatment }}</strong>
            </p>
          </div>
        </div>
      </div>
      <div class="row" v-if="choices.design.length > 1">
        <div class="small-12 medium-6 columns lp end">
          <div :class="{'error': errors.has(choices.lensDesignLabel) }">
            <label for="designID">{{choices.lensDesignLabel}}: *</label>
            <select id='designId' v-validate data-vv-rules="required" class="orderinput-select" @change="handleDesignChange" :name="choices.lensDesignLabel" v-model="sampleobject.design">
              <option v-for="c in choices.design" :value="c.value" :key="c.value">{{c.label}}</option>
            </select>
            <p class="error" v-if="errors.has(choices.lensDesignLabel)">{{ errors.first(choices.lensDesignLabel) }}</p>
          </div>
        </div>
      </div>
      <div class="row" v-if="choices.material.length >= 1">
        <div class="small-12 medium-6 columns lp end">
          <div :class="{'error': errors.has(choices.lensMaterialLabel) }">
            <label for="materialId">{{choices.lensMaterialLabel}}: *</label>
            <select id='materialId' v-validate data-vv-rules="required" class="orderinput-select" @change="handleMaterialChange" :disabled="disableMaterial" :name="choices.lensMaterialLabel" v-model="sampleobject.material">
              <option v-for="c in choices.material" :value="c.value" :key="c.value">{{c.label}}</option>
            </select>
            <p class="error" v-if="errors.has(choices.lensMaterialLabel)">{{ errors.first(choices.lensMaterialLabel) }}</p>
          </div>
        </div>
      </div>
      <div class="row" v-if="choices.photochromic.length >= 1">
        <div class="small-12 medium-6 columns lp end">
          <div :class="{'error': errors.has(choices.lensPhotochromicLabel) }">
            <label for="photochromicId">{{choices.lensPhotochromicLabel}}: *</label>
            <select id='photochromicId' v-validate data-vv-rules="required" class="orderinput-select" @change="handlePhotochromicChange" :disabled="disablePhotochromic" :name="choices.lensPhotochromicLabel" v-model="sampleobject.photochromic">
              <option
                :disabled="chosenDesign == 'Varilux X Design' && c.value == 'XTRP-GRY0-00' && sampleobject.programId == 'TROPP'"
                v-for="c in choices.photochromic" :value="c.value" :key="c.value">
                {{c.label}}
              </option>
            </select>
            <p class="error" v-if="errors.has(choices.lensPhotochromicLabel)">{{ errors.first(choices.lensPhotochromicLabel) }}</p>
          </div>
        </div>
      </div>
      <div class="row" v-if="choices.treatment.length >= 1">
        <div class="small-12 medium-6 columns lp end">
          <div :class="{'error': errors.has(choices.lensTreatmentLabel) }">
            <label for="treatmentID">{{choices.lensTreatmentLabel}}: *</label>
            <select id='treatmentId' v-validate data-vv-rules="required" class="orderinput-select" @change="handleTreatmentChange" :disabled="disableTreatment" :name="choices.lensTreatmentLabel" v-model="sampleobject.treatment">
              <option v-for="c in choices.treatment" :value="c.value" :key="c.value">{{c.label}}</option>
            </select>
            <p class="error" v-if="errors.has(choices.lensTreatmentLabel)">{{ errors.first(choices.lensTreatmentLabel) }}</p>
          </div>
        </div>
      </div>
      <div class="row" v-if="showTint && showTintDropdown">
        <div class="small-12 medium-6 columns lp end">
          <div :class="{'error': errors.has('Tint') }">
            <label for="tintId">Tint:</label>
            <select id='tintId' v-model="sampleobject.tint" @change="handleTintChange" class="orderinput-select">
              <option v-for="tint in choices.tint" :value="tint.value" :key="tint.value">{{tint.label}}</option>
            </select>
            <p class="error" v-if="errors.has('Tint')">{{ errors.first('Tint') }}</p>
          </div>
        </div>
      </div>
      <div class="row" v-if="sampleobject.tint">
        <div class="small-12 medium-6 columns lp end">
          <div :class="{'error': errors.has('Tint Color & Intensity') }">
            <label for="tintColorAndIntensityId">Tint Color & Intensity: *</label>
            <select id='tintColorAndIntensityId' v-validate data-vv-rules="required" :disabled="disableTintComment" class="orderinput-select" :name="'Tint Color & Intensity'" v-model="sampleobject.tintColor">
              <option v-for="color in choices.tintcolors" :value="color.value" :key="color.value">{{color.label}}</option>
            </select>
            <p class="error" v-if="errors.has('Tint Color & Intensity')">{{ errors.first('Tint Color & Intensity') }}</p>
          </div>
        </div>
      </div>
      <div class="row small-collapse">
        <p class="small-text"> Note: Most prescriptions will not have base and prism.<br></p>
        <div class="small-12 medium-4 columns">
          <table class="rxinfo-table">
            <thead class="rxinfo-thead">
            <tr>
              <th class="rxinfo-TableInputBox rxinfo-leading-col"></th>
              <th>Sph. *</th>
              <th>Cyl.</th>
              <th>Axi.</th>
              <th v-if="sampleobject.isProgressive">Add.
                <span class="rxinfo-asterik" v-if="sampleobject.isProgressive">*</span>
              </th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td class="rxinfo-TableInputBox rxinfo-leading-col">R</td>
              <td class="rxinfo-TableInputBox">
                <div :class="{'error': errors.has('right sphere') }">
                  <rx-field :useSign="true" :required="true" :min="-12" :max="9" :precision="2" type="text" name="right sphere" v-model='sampleobject.resph'></rx-field>
                </div>
              </td>
              <td class="rxinfo-TableInputBox">
                <div :class="{'error': errors.has('right cylinder') }">
                  <rx-field :useSign="true" :required="reCylRequired" :min="-6" :max="6" :precision="2" type="text" name="right cylinder" v-model='sampleobject.recyl'></rx-field>
                </div>
              </td>
              <td class="rxinfo-TableInputBox">
                <div :class="{'error': errors.has('right axis') }">
                  <rx-field :required="reAxisRequired" :min="0" :max="180" :precision="0" type="text" name="right axis" v-model='sampleobject.reaxis'></rx-field>
                </div>
              </td>
              <td class="rxinfo-TableInputBox" v-if="sampleobject.isProgressive">
                <div :class="{'error': errors.has('right add') }">
                  <rx-field :useSign="true" :required="sampleobject.isProgressive" :min="0" :max="4" :precision="2" type="text" name="right add" v-model='sampleobject.readd'></rx-field>
                </div>
              </td>
            </tr>
            <tr>
              <td class="rxinfo-TableInputBox rxinfo-leading-col">L</td>
              <td class="rxinfo-TableInputBox">
                <div :class="{'error': errors.has('left sphere') }">
                  <rx-field :useSign="true" :required="true" :min="-12" :max="9" :precision="2" type="text" name="left sphere" v-model='sampleobject.lesph'></rx-field>
                </div>
              </td>
              <td class="rxinfo-TableInputBox">
                <div :class="{'error': errors.has('left cylinder') }">
                  <rx-field :useSign="true" :required="leCylRequired" :min="-6" :max="6" :precision="2" type="text" name="left cylinder" v-model='sampleobject.lecyl'></rx-field>
                </div>
              </td>
              <td class="rxinfo-TableInputBox">
                <div :class="{'error': errors.has('left axis') }">
                  <rx-field :required="leAxisRequired" :min="0" :max="180" :precision="0" type="text" name="left axis" v-model='sampleobject.leaxis'></rx-field>
                </div>
              </td>
              <td class="rxinfo-TableInputBox" v-if="sampleobject.isProgressive">
                <div :class="{'error': errors.has('left add') }">
                  <rx-field :useSign="true" :required="sampleobject.isProgressive" :min="0" :max="4" :precision="2" type="text" name="left add" v-model='sampleobject.leadd'></rx-field>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="small-12 medium-5 columns">
          <table class="rxinfo-table">
            <thead class="rxinfo-thead">
            <tr>
              <th class="show-for-small-only rxinfo-leading-col"></th>
              <th>H. Prism <span v-if="reHPrismRequired || leHPrismRequired" style="font-size: inherit; font-weight: inherit;">*</span></th>
              <th>H. Base <span v-if="reHPrismDirectionRequired || leHPrismDirectionRequired" style="font-size: inherit; font-weight: inherit;">*</span></th>
              <th>V. Prism <span v-if="reVPrismRequired || leVPrismRequired" style="font-size: inherit; font-weight: inherit;">*</span></th>
              <th>V. Base <span v-if="reVPrismDirectionRequired || leVPrismDirectionRequired" style="font-size: inherit; font-weight: inherit;">*</span></th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td class="show-for-small-only rxinfo-leading-col">R</td>
              <td class="rxinfo-TableInputBox25">
                <div :class="{'error': errors.has('right h prism') }">
                  <rx-field :required="reHPrismRequired" :min="0" :max="99.75" :precision="2" input type="text" name="right h prism" v-model='sampleobject.rehorizPrismValue'></rx-field>
                </div>
              </td>
              <td class="rxinfo-TableInputBox25">
                <div>
                  <select :style="{'border-color': errors.has('right h prism direction') ? 'red' : '' }" v-validate="reHPrismDirectionRequired" class="rxinfo-select" name="right h prism direction" v-model="sampleobject.rehorizPrismDirection">
                    <option selected value> </option>
                    <option value="000">IN</option>
                    <option value="180">OUT</option>
                  </select>
                </div>
              </td>
              <td class="rxinfo-TableInputBox25">
                <div :class="{'error': errors.has('right v prism') }">
                  <rx-field :required="reVPrismRequired" :min="0" :max="99.75" :precision="2" input type="text" name="right v prism" v-model='sampleobject.reverticalPrismValue'></rx-field>
                </div>
              </td>
              <td class="rxinfo-TableInputBox25">
                <div :class="{'error': errors.has('right v prism direction') }">
                  <select :style="{'border-color': errors.has('right v prism direction') ? 'red' : '' }" v-validate="reVPrismDirectionRequired" class="rxinfo-select" name="right v prism direction" v-model="sampleobject.reverticalPrismDirection">
                    <option selected value> </option>
                    <option value="090">UP</option>
                    <option value="270">DOWN</option>
                  </select>
                </div>
              </td>
            </tr>
            <tr>
              <td class="show-for-small-only rxinfo-leading-col">L</td>
              <td class="rxinfo-TableInputBox">
                <div :class="{'error': errors.has('left h prism') }">
                  <rx-field :required="leHPrismRequired" :min="0" :max="99.75" :precision="2" input type="text" name="left h prism" v-model='sampleobject.lehorizPrismValue'></rx-field>
                </div>
              </td>
              <td class="rxinfo-TableInputBox">
                <div :class="{'error': errors.has('left h prism direction') }">
                  <select :style="{'border-color': errors.has('left h prism direction') ? 'red' : '' }" v-validate="leHPrismDirectionRequired" class="rxinfo-select" name="left h prism direction" v-model="sampleobject.lehorizPrismDirection">
                    <option selected value> </option>
                    <option value="180">IN</option>
                    <option value="000">OUT</option>
                  </select>
                </div>
              </td>
              <td class="rxinfo-TableInputBox">
                <div :class="{'error': errors.has('left v prism') }">
                  <rx-field :required="leVPrismRequired" :min="0" :max="99.75" :precision="2" input type="text" name="left v prism" v-model='sampleobject.leverticalPrismValue'></rx-field>
                </div>
              </td>
              <td class="rxinfo-TableInputBox">
                <div :class="{'error': errors.has('left b prism direction') }">
                  <select :style="{'border-color': errors.has('left v prism direction') ? 'red' : '' }" v-validate="leVPrismDirectionRequired" class="rxinfo-select" name="left v prism direction" v-model="sampleobject.leverticalPrismDirection">
                    <option selected value> </option>
                    <option value="090">UP</option>
                    <option value="270">DOWN</option>
                  </select>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="small-12 medium-3 columns end">
          <table class="rxinfo-table">
            <thead class="rxinfo-thead">
            <tr>
              <th class="show-for-small-only"></th>
              <th>Dist PD *</th>
              <th>Eye Height *</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td class="show-for-small-only  rxinfo-leading-col">R</td>
              <td class="rxinfo-TableInputBox">
                <div :class="{'error': errors.has('right distance PD') }">
                  <rx-field :required="true" :precision="1" :min="20.00" :max="39.9" type="text" name="right distance PD" v-model='sampleobject.redistPD'></rx-field>
                </div>
              </td>
              <td class="rxinfo-TableInputBox">
                <div :class="{'error': errors.has('right eyeheight') }">
                  <rx-field :required="true" :precision="2" :min="14" :max="40" type="text" name="right eyeheight" v-model='sampleobject.resegHeight'></rx-field>
                </div>
              </td>
            </tr>
            <tr>
              <td class="show-for-small-only rxinfo-leading-col">L</td>
              <td class="rxinfo-TableInputBox">
                <div :class="{'error': errors.has('left distance PD') }">
                  <rx-field :required="true" :precision="1" :min="20" :max="39.9" type="text" name="left distance PD" v-model='sampleobject.ledistPD'></rx-field>
                </div>
              </td>
              <td class="rxinfo-TableInputBox">
                <div :class="{'error': errors.has('left eyeheight') }">
                  <rx-field :required="true" :precision="2" :min="14" :max="40" type="text" name="left eyeheight" v-model='sampleobject.lesegHeight'></rx-field>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="columns small-12">
          <v-popover :auto-hide="false">
            <button class="tooltip-target b3" type="button" v-tooltip.top-center>
              <p class="small-text text-blue link" style="text-decoration: underline;">What are PD and fitting height?</p>
            </button>
            <template slot="popover">
              <div class="download-image">
                <a class="small-text" @click="downloadImage('/images/PDandEyeHeightImage.png')"> Download </a>
                <a v-close-popover class="small-text"> <span class="icon-cross"></span></a>
              </div>
              <img src="/images/PDandEyeHeightImage.png">
            </template>
          </v-popover>
          <div class="error">
            <p class="error" v-if="errors.has('right sphere')">{{ errors.first('right sphere') }}</p>
            <p class="error" v-if="errors.has('right cylinder')">{{ errors.first('right cylinder') }}</p>
            <p class="error" v-if="errors.has('right axis')">{{ errors.first('right axis') }}</p>
            <p class="error" v-if="errors.has('right add')">{{ errors.first('right add') }}</p>
            <p class="error" v-if="errors.has('left sphere')">{{ errors.first('left sphere') }}</p>
            <p class="error" v-if="errors.has('left cylinder')">{{ errors.first('left cylinder') }}</p>
            <p class="error" v-if="errors.has('left axis')">{{ errors.first('left axis') }}</p>
            <p class="error" v-if="errors.has('left add')">{{ errors.first('left add') }}</p>
          </div>
          <div class="error">
            <p class="error" v-if="errors.has('right h prism')">{{ errors.first('right h prism') }}</p>
            <p class="error" v-if="errors.has('right h prism direction')">{{ errors.first('right h prism direction') }}</p>
            <p class="error" v-if="errors.has('right v prism')">{{ errors.first('right v prism') }}</p>
            <p class="error" v-if="errors.has('right v prism direction')">{{ errors.first('right v prism direction') }}</p>
            <p class="error" v-if="errors.has('left h prism')">{{ errors.first('left h prism') }}</p>
            <p class="error" v-if="errors.has('left h prism direction')">{{ errors.first('left h prism direction') }}</p>
            <p class="error" v-if="errors.has('left v prism')">{{ errors.first('left v prism') }}</p>
            <p class="error" v-if="errors.has('left v prism direction')">{{ errors.first('left v prism direction') }}</p>
          </div>
          <div class="error">
            <p class="error" v-if="errors.has('right distance PD')">{{ errors.first('right distance PD') }}</p>
            <p class="error" v-if="errors.has('right eyeheight')">{{ errors.first('right eyeheight') }}</p>
            <p class="error" v-if="errors.has('left distance PD')">{{ errors.first('left distance PD') }}</p>
            <p class="error" v-if="errors.has('left eyeheight')">{{ errors.first('left eyeheight') }}</p>
          </div>
        </div>

        <!-- ─── Track-only: NVB ─── -->
        <div v-if="showTrackInput" class="small-12 columns end">
          <div class="medium-4 columns lp">
            <div :class="{'error': !hasInvalidNVBValue }">
              <labeled-input
                validation="required|alpha_num|min:7|max:7"
                @input="formatNVB"
                label="NVB *"
                name="NVB"
                v-model="sampleobject.NVB"
              ></labeled-input>
              <p class="error" v-if="!hasInvalidNVBValue">Invalid NVB value</p>
            </div>
          </div>
        </div>

        <!-- ─── Stylistic-only: Wrap Angle + Base Curve + Panto ─── -->
        <div v-if="showStylisticInput" class="small-12 columns end">
          <div class="medium-4 columns lp">
            <label for="wrapAngle">Wrap Angle *</label>
            <div :class="{'error': errors.has('Wrap') }">
              <rx-field :decimalEnabled="false" :required="true" :min="0" :max="25" type="text" name="Wrap" id="wrapAngle" v-model='sampleobject.WrapAngle' v-tooltip.hover title="Must be between 0 and 25"></rx-field>
            </div>
            <p class="small-text text-blue">Must be between 0 and 25</p>
          </div>
          <div class="medium-4 columns lp">
            <label for="sPBaseCurve">Base Curve *</label>
            <div :class="{'error': errors.has('BaseCurve') }">
              <rx-field
                :required="true"
                :precision="2"
                :min="4.25"
                :max="8.5"
                :decimalEnabled="true"
                type="text"
                name="BaseCurve"
                v-model='sampleobject.SPBaseCurve'
                v-tooltip.hover
                title="Must be between 4.25 and 8.5">
              </rx-field>
            </div>
            <p class="small-text text-blue">Must be between 4.25 and 8.5</p>
          </div>
          <div class="medium-4 columns lp">
            <label for="pantoAngle">Panto</label>
            <div :class="{'error': errors.has(pantoFieldName) }">
              <rx-field
                :useSign="true"
                :required="pantoRequired"
                :min="-5"
                :max="25"
                type="text"
                :decimalEnabled="false"
                :name="pantoFieldName"
                v-model="sampleobject.PantoAngle"
                v-tooltip.hover
                title="Must be between -5 and 25">
              </rx-field>
            </div>
            <p class="small-text text-blue">Must be between -5 and 25</p>
          </div>
        </div>

        <!-- ─── Track-only: Wrap Angle + Initials + Panto ─── -->
        <div v-if="showTrackInput" class="small-12 columns end">
          <div class="medium-4 columns lp">
            <label for="wrapAngle">Wrap Angle *</label>
            <div :class="{'error': errors.has('Wrap') }">
              <rx-field :decimalEnabled="false" :required="true" :min="0" :max="25" type="text" name="Wrap" id="wrapAngle" v-model='sampleobject.WrapAngle' v-tooltip.hover title="Must be between 0 and 25"></rx-field>
            </div>
            <p class="small-text text-blue">Must be between 0 and 25</p>
          </div>
          <div class="medium-4 columns lp">
            <labeled-input
              validation="alpha_num"
              label="Initials"
              name="Initials"
              v-model="sampleobject.Initials"
            ></labeled-input>
          </div>
          <div class="medium-4 columns lp">
            <label for="pantoAngle">Panto *</label>
            <div :class="{'error': errors.has(pantoFieldName) }">
              <rx-field
                :useSign="true"
                :required="true"
                :min="-5"
                :max="25"
                type="text"
                :decimalEnabled="false"
                :name="pantoFieldName"
                v-model="sampleobject.PantoAngle"
                v-tooltip.hover
                title="Must be between -5 and 25">
              </rx-field>
            </div>
            <p class="small-text text-blue">Must be between -5 and 25</p>
          </div>
        </div>

        <!-- ─── Default: Wrap Angle + Panto ─── -->
        <div v-if="!showTrackInput && !showStylisticInput" class="small-12 columns end">
          <div class="medium-6 columns lp">
            <label for="wrapAngle">Wrap Angle</label>
            <div :class="{'error': errors.has('Wrap') }">
              <rx-field :decimalEnabled="false" :min="0" :max="25" type="text" name="Wrap" id="wrapAngle" v-model='sampleobject.WrapAngle' v-tooltip.hover title="Must be between 0 and 25"></rx-field>
            </div>
            <p class="small-text text-blue">Must be between 0 and 25</p>
          </div>
          <div class="medium-6 columns lp">
            <label for="pantoAngle">Panto</label>
            <div :class="{'error': errors.has(pantoFieldName) }">
              <rx-field
                :useSign="true"
                :required="pantoRequired"
                :min="-5"
                :max="25"
                type="text"
                :decimalEnabled="false"
                :name="pantoFieldName"
                v-model="sampleobject.PantoAngle"
                v-tooltip.hover
                title="Must be between -5 and 25">
              </rx-field>
            </div>
            <p class="small-text text-blue">Must be between -5 and 25</p>
          </div>
        </div>


        <!-- ─── Vertex Distance — Stylistic (both optional) ─── -->
        <div v-if="showStylisticInput" class="small-12 columns end">
          <div class="medium-6 columns lp">
            <label for="rightVertexDistance">Vertex Distance RE</label>
            <div :class="{'error': errors.has('RightVertexDistance') }">
              <rx-field :required="false" :min="5" :max="22" type="text" :decimalEnabled="false" name="RightVertexDistance" v-model='sampleobject.RightVertexDistance' v-tooltip.hover title="Must be between 5 and 22"></rx-field>
            </div>
            <p class="small-text text-blue">Must be between 5 and 22</p>
          </div>
          <div class="medium-6 columns lp">
            <label for="leftVertexDistance">Vertex Distance LE</label>
            <div :class="{'error': errors.has('LeftVertexDistance') }">
              <rx-field :required="false" :min="5" :max="22" type="text" :decimalEnabled="false" name="LeftVertexDistance" v-model='sampleobject.LeftVertexDistance' v-tooltip.hover title="Must be between 5 and 22"></rx-field>
            </div>
            <p class="small-text text-blue">Must be between 5 and 22</p>
          </div>
        </div>

        <!-- ─── Vertex Distance — Track (RE required, LE optional) ─── -->
        <div v-if="showTrackInput" class="small-12 columns end">
          <div class="medium-6 columns lp">
            <label for="rightVertexDistance">Vertex Distance RE *</label>
            <div :class="{'error': errors.has('RightVertexDistance') }">
              <rx-field :required="true" :min="5" :max="22" type="text" :decimalEnabled="false" name="RightVertexDistance" v-model='sampleobject.RightVertexDistance' v-tooltip.hover title="Must be between 5 and 22"></rx-field>
            </div>
            <p class="small-text text-blue">Must be between 5 and 22</p>
          </div>
          <div class="medium-6 columns lp">
            <label for="leftVertexDistance">Vertex Distance LE *</label>
            <div :class="{'error': errors.has('LeftVertexDistance') }">
              <rx-field :required="false" :min="5" :max="22" type="text" :decimalEnabled="false" name="LeftVertexDistance" v-model='sampleobject.LeftVertexDistance' v-tooltip.hover title="Must be between 5 and 22"></rx-field>
            </div>
            <p class="small-text text-blue">Must be between 5 and 22</p>
          </div>
        </div>

        <!-- ─── Vertex Distance — Default (both optional) ─── -->
        <div v-if="!showTrackInput && !showStylisticInput" class="small-12 columns end">
          <div class="medium-6 columns lp">
            <label for="rightVertexDistance">Vertex Distance RE</label>
            <div :class="{'error': errors.has('RightVertexDistance') }">
              <rx-field :min="5" :max="22" type="text" :decimalEnabled="false" name="RightVertexDistance" v-model='sampleobject.RightVertexDistance' v-tooltip.hover title="Must be between 5 and 22"></rx-field>
            </div>
            <p class="small-text text-blue">Must be between 5 and 22</p>
          </div>
          <div class="medium-6 columns lp">
            <label for="leftVertexDistance">Vertex Distance LE</label>
            <div :class="{'error': errors.has('LeftVertexDistance') }">
              <rx-field :min="5" :max="22" type="text" :decimalEnabled="false" name="LeftVertexDistance" v-model='sampleobject.LeftVertexDistance' v-tooltip.hover title="Must be between 5 and 22"></rx-field>
            </div>
            <p class="small-text text-blue">Must be between 5 and 22</p>
          </div>
        </div>

      </div>
    </fieldset>
  </div>
</template>

<script>
function getChoice(choices, choice) {
  if (choices == null) return '';
  if (choices.length == 1) return choices[0].label;
  for (let d of choices) {
    if (d.value === choice) return d.label;
  }
  return '';
}

function getChoiceValue(choices, choice) {
  if (choices == null) return '';
  if (choices.length == 1) return choices[0].value;
  for (let d of choices) {
    if (d.value === choice) return d.value;
  }
  return null;
}

import RxField from "@/components/order/RxField";
import LabeledInput from "@/components/shared/LabeledInput";

export default {
  props: ["selected", "sampleobject", "choices", "programChoice"],
  components: { RxField, LabeledInput },
  inject: ["$validator"],
  data() {
    return {
      hasInvalidNVBValue: true,
      disableMaterial: true,
      disablePhotochromic: true,
      disableTreatment: true,
      disableTintComment: true,
      programId: null,
      showTintDropdown: false,
      showTintColorAndIntensityDropdown: false,
      allowTint: false,
      // Snapshot of whichever pantoFieldName was active before the last design
      // change. Used in handleDesignChange to remove exactly one stale error
      // instead of sweeping a hard-coded list of all possible panto variants.
      previousPantoFieldName: null,
    };
  },

  computed: {
    chosenDesign() {
      return getChoice(this.choices.design, this.sampleobject.design);
    },
    chosenMaterial() {
      return getChoice(this.choices.material, this.sampleobject.material);
    },
    chosenTreatment() {
      return getChoice(this.choices.treatment, this.sampleobject.treatment);
    },
    chosenPhotochromic() {
      return getChoice(this.choices.photochromic, this.sampleobject.photochromic);
    },
    chosenTint() {
      return getChoice(this.choices.tint, this.sampleobject.tint);
    },

    // ─── Dynamic Panto ────────────────────────────────────────────────────────
    // Single source of truth. To add a new design block in future, add one
    // branch here and bind :name="pantoFieldName" in the template — done.
    pantoFieldName() {
      if (this.showTrackInput)     return 'Panto';   // required
      if (this.showStylisticInput) return 'PantoA';  // optional
      return 'PantoB';                               // optional (default)
      // Future: if (this.showNewDesign) return 'PantoC';
    },
    pantoRequired() {
      return this.showTrackInput; // only Track makes Panto mandatory
    },
    // ─────────────────────────────────────────────────────────────────────────

    reCylRequired() { return this.sampleobject.reaxis != null; },
    leCylRequired() { return this.sampleobject.leaxis != null; },
    reAxisRequired() { return this.sampleobject.recyl != null; },
    leAxisRequired() { return this.sampleobject.lecyl != null; },
    reHPrismRequired() {
      return this.sampleobject.rehorizPrismDirection != null &&
             this.sampleobject.rehorizPrismDirection.trim() !== "";
    },
    reHPrismDirectionRequired() {
      return this.sampleobject.rehorizPrismValue != null ? "required" : "";
    },
    reVPrismRequired() {
      return this.sampleobject.reverticalPrismDirection != null &&
             this.sampleobject.reverticalPrismDirection.trim() !== "";
    },
    reVPrismDirectionRequired() {
      return this.sampleobject.reverticalPrismValue != null ? "required" : "";
    },
    leHPrismRequired() {
      return this.sampleobject.lehorizPrismDirection != null &&
             this.sampleobject.lehorizPrismDirection.trim() !== "";
    },
    leHPrismDirectionRequired() {
      return this.sampleobject.lehorizPrismValue != null ? "required" : "";
    },
    leVPrismRequired() {
      return this.sampleobject.leverticalPrismDirection != null &&
             this.sampleobject.leverticalPrismDirection.trim() !== "";
    },
    leVPrismDirectionRequired() {
      return this.sampleobject.leverticalPrismValue != null ? "required" : "";
    },
    showTrackInput() {
      return (
        this.sampleobject.design === 'VXXRTRACK' ||
        this.sampleobject.design === 'VXPHYEXTTRACK'
      );
    },
    showStylisticInput() {
      return (
        this.sampleobject.design === 'STYLISTICW' ||
        this.sampleobject.design === 'SVWRAPSP'
      );
    },
    getProgramId() {
      return this.sampleobject.couponCode.substring(0, 5);
    },
    showTint() {
      return this.allowTint;
    },
  },

  mounted() {
    this.sampleobject.design       = getChoiceValue(this.choices.design,       this.sampleobject.design);
    this.sampleobject.treatment    = getChoiceValue(this.choices.treatment,    this.sampleobject.treatment);
    this.sampleobject.material     = getChoiceValue(this.choices.material,     this.sampleobject.material);
    this.sampleobject.photochromic = getChoiceValue(this.choices.photochromic, this.sampleobject.photochromic);

    if (this.choices.treatment && this.choices.treatment.length === 1) {
      this.sampleobject.treatment = this.choices.treatment[0].value;
    }

    // Seed the snapshot so the very first design change knows what to clear.
    this.previousPantoFieldName = this.pantoFieldName;

    this.isNVBValid();
    this.handleDisabling();
    this.checkTintAllowed();
    this.getGeoTagId();

    if (this.sampleobject && this.sampleobject.tintColor != null) {
      this.disableTintComment = false;
    } else {
      this.disableTintComment = !(this.sampleobject && this.sampleobject.tint);
    }

    if (this.choices && this.choices.tint) {
      this.showTintDropdown = (
        this.sampleobject.photochromic === "NONE-NONE-00" &&
        this.choices.tint.length >= 1
      ) || this.sampleobject.tint;
    } else {
      this.showTintDropdown = !!this.sampleobject.tint;
    }
  },

  methods: {
    async downloadImage(url) {
      axios({
        url: window.location.origin + url,
        method: 'GET',
        responseType: 'blob',
      }).then((response) => {
        const fileURL  = window.URL.createObjectURL(new Blob([response.data]));
        const fileLink = document.createElement('a');
        fileLink.href  = fileURL;
        fileLink.setAttribute('download', 'PDandEyeHeightImage.png');
        document.body.appendChild(fileLink);
        fileLink.click();
      });
    },

    getGeoTagId() {
      axios
        .get(`/order/${this.sampleobject.couponCode}`)
        .then(response => { this.geoTagId = response.data; })
        .catch(error   => { this.handleError(error); });
    },

    checkTintAllowed() {
      const programId = this.sampleobject.programId || this.getProgramId;
      axios
        .get(`/coupon/${this.sampleobject.couponCode}/programChoice/${programId}`)
        .then(response => { this.allowTint = response.data.programDetails.allowTint; });
    },

    isNVBValid() {
      const restrictedLetters = ['o', 'i', 'u', '0'];
      if (this.sampleobject.NVB) {
        const nvbLowerCase = this.sampleobject.NVB.toLowerCase();
        this.hasInvalidNVBValue = !restrictedLetters.some(l => nvbLowerCase.includes(l));
        this.$emit('hasInvalidNVBValue', !this.hasInvalidNVBValue);
      } else {
        this.hasInvalidNVBValue = true;
      }
    },

    formatNVB() {
      this.sampleobject.NVB = this.sampleobject.NVB.toUpperCase();
      this.isNVBValid();
    },

    async getProgramService() {
      try {
        const programId = this.sampleobject.programId || this.getProgramId;
        const response  = await axios.get('/order/GetProgram', {
          params: {
            geoTag:        this.geoTagId,
            couponCode:    this.sampleobject.couponCode,
            programType:   this.sampleobject.programType,
            lensProgramId: programId,
            programId,
            design:        this.sampleobject.design,
            material:      this.sampleobject.material,
            treatment:     this.sampleobject.treatment,
            photochromic:  this.sampleobject.photochromic,
            tint:          this.sampleobject.tint,
          },
        });
        this.choices.material     = this.filterResponse(response.data.MaterialChoices);
        this.choices.design       = this.filterResponse(response.data.DesignChoices);
        this.choices.photochromic = this.filterResponse(response.data.PhotochromicChoices);
        this.choices.treatment    = this.filterResponse(response.data.TreatmentChoices);
        this.choices.tint         = this.filterResponse(response.data.TintChoices);
        this.choices.tintcolors   = this.filterResponse(response.data.TintColorChoices);
      } catch (error) {
        console.error('Error calling GetProgram service:', error);
      }
    },

    async handleDesignChange() {
      // ── Precise panto error removal ──────────────────────────────────────
      // At this point sampleobject.design has already updated (v-model), so
      // pantoFieldName now reflects the NEW design. We remove the error that
      // was registered under the PREVIOUS name, then snapshot the new one.
      if (this.previousPantoFieldName) {
        this.$validator.errors.remove(this.previousPantoFieldName);
      }
      // ─────────────────────────────────────────────────────────────────────

      if (
        (this.choices.treatment.length > 1 && this.choices.treatment.length > 1) ||
        this.choices.photochromic.length > 1
      ) {
        this.resetAndDisable(['material', 'photochromic', 'treatment', 'tint', 'tintcolor']);
      }

      this.sampleobject.photochromic = getChoiceValue(this.choices.photochromic, this.sampleobject.photochromic);
      this.sampleobject.treatment    = getChoiceValue(this.choices.treatment,    this.sampleobject.treatment);
      this.sampleobject.material     = getChoiceValue(this.choices.material,     this.sampleobject.material);

      await this.getProgramService();

      // Snapshot current name AFTER the await so computed reflects the new design.
      this.previousPantoFieldName = this.pantoFieldName;

      this.disableMaterial     = !this.chosenDesign;
      this.disablePhotochromic = !this.chosenMaterial;
      this.disableTreatment    = !this.chosenPhotochromic;

      if (this.sampleobject.design && this.sampleobject.material && this.sampleobject.photochromic === null) {
        this.disableTreatment = false;
      }
      if (this.sampleobject.design && this.choices.material.length === 1) {
        this.handleMaterialChange();
      }
    },

    async handleMaterialChange() {
      if (this.choices.treatment.length > 1 && this.choices.photochromic.length > 1) {
        this.resetAndDisable(['photochromic', 'treatment']);
      }
      this.sampleobject.photochromic = getChoiceValue(this.choices.photochromic, this.chosenPhotochromic);
      this.sampleobject.material     = getChoiceValue(this.choices.material,     this.sampleobject.material);
      await this.getProgramService();
      this.disablePhotochromic = !this.chosenMaterial;
      this.disableTreatment    = !this.chosenPhotochromic;
    },

    async handlePhotochromicChange() {
      this.sampleobject.treatment = null;
      await this.getProgramService();
      await this.checkTintAllowed();
      if (this.choices.treatment && this.choices.treatment.length === 1) {
        this.sampleobject.treatment = this.choices.treatment[0].value;
      }
      this.disableTreatment = !this.chosenPhotochromic;
    },

    async handleTreatmentChange() {
      this.sampleobject.tint      = null;
      this.sampleobject.tintColor = null;
      await this.getProgramService();
      await this.checkTintAllowed();
      this.showTintDropdown = (
        this.sampleobject.photochromic === "NONE-NONE-00" &&
        this.choices.tint.length >= 1
      ) || this.sampleobject.tint;
    },

    async handleTintChange() {
      await this.getProgramService();
      this.disableTintComment = this.sampleobject.tintColor != null
        ? false
        : !this.chosenTint;
    },

    resetAndDisable(fields) {
      fields.forEach(field => (this.sampleobject[field] = null));
      this.disableFields(fields);
    },

    disableFields(fields) {
      fields.forEach(field => {
        this[`disable${field.charAt(0).toUpperCase() + field.slice(1)}`] = true;
      });
    },

    handleDisabling() {
      this.disableMaterial     = !this.chosenDesign;
      this.disablePhotochromic = !this.chosenMaterial;
      this.disableTreatment    = !this.chosenPhotochromic;
    },

    filterResponse(response) {
      if (response === undefined) return;
      return response.map(item => ({ label: item.Label, value: item.Value }));
    },
  },

  watch: {
    'sampleobject.photochromic'(newValue) {
      if (newValue !== "NONE-NONE-00") {
        this.sampleobject.tint       = null;
        this.sampleobject.tintcolors = null;
      }
    },

    // Handles programmatic design changes (not triggered via the select).
    // Uses $nextTick so pantoFieldName has resolved to the new value
    // before we snapshot it.
    'sampleobject.design'() {
      if (this.previousPantoFieldName) {
        this.$validator.errors.remove(this.previousPantoFieldName);
      }
      this.$nextTick(() => {
        this.previousPantoFieldName = this.pantoFieldName;
      });
    },

    'sampleobject.SPBaseCurve'(newValue, oldValue) {
      console.log("BaseCurve changed from", oldValue, "to", newValue);
    },
  },
};
</script>

<style>
table tbody tr:nth-child(even) { background-color: #fff; }

.rxinfo-select {
  font-size: 11pt;
  display: table-cell;
  width: 100%;
  height: 100%;
  margin: 0;
}
.rxinfo-thead { background-color: ghostwhite; }
.rxinfo-TableInputBox { margin: 0; padding: 0; }
.rxinfo-TableInputBox25 { margin: 0; padding: 0; width: 25%; }
.rxinfo-table input:focus,
.rxinfo-table select:focus { -webkit-box-shadow: none; box-shadow: none; }
.rxinfo-table {
  border: 1px solid darkgray;
  width: 100%;
  border-collapse: collapse;
  font-size: 8pt;
  font-style: normal;
}
.rxinfo-smallpad { padding-bottom: 10px; }
.rxinfo-table tr,
.rxinfo-table th { border: 1px solid darkgray; border-collapse: collapse; }
.rxinfo-asterik { font-size: 8pt; font-style: normal; }
.rxinfo-TableInputBox div { margin: auto; padding: 0; height: 100%; width: 100%; }
.rxinfo-leading-col { width: 25px; text-align: center; }

.tooltip { display: block !important; z-index: 1; cursor: pointer; }
.tooltip .tooltip-inner { background: white; color: white; border-radius: 16px; width: 750px; }
.tooltip .tooltip-arrow { width: 0; height: 0; position: absolute; margin: 5px; border-color: white; }
.tooltip[x-placement^="top"] { margin-bottom: 5px; }
.tooltip[x-placement^="top"] .tooltip-arrow {
  border-width: 5px 5px 0 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  bottom: -5px; left: calc(50% - 5px); margin-top: 0; margin-bottom: 0;
}
.tooltip[x-placement^="bottom"] { margin-top: 5px; }
.tooltip[x-placement^="bottom"] .tooltip-arrow {
  border-width: 0 5px 5px 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-top-color: transparent !important;
  top: -5px; left: calc(50% - 5px); margin-top: 0; margin-bottom: 0;
}
.tooltip[x-placement^="right"] { margin-left: 5px; }
.tooltip[x-placement^="right"] .tooltip-arrow {
  border-width: 5px 5px 5px 0;
  border-left-color: transparent !important;
  border-top-color: transparent !important;
  border-bottom-color: transparent !important;
  left: -5px; top: calc(50% - 5px); margin-left: 0; margin-right: 0;
}
.tooltip[x-placement^="left"] { margin-right: 5px; }
.tooltip[x-placement^="left"] .tooltip-arrow {
  border-width: 5px 0 5px 5px;
  border-top-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  right: -5px; top: calc(50% - 5px); margin-left: 0; margin-right: 0;
}
.tooltip[aria-hidden='true'] { visibility: hidden; opacity: 0; transition: opacity .15s, visibility .15s; }
.tooltip[aria-hidden='false'] { visibility: visible; opacity: 1; transition: opacity .15s; }
.tooltip { padding: 0 .75rem; max-width: 210px; }
.tooltip.popover { color: #f9f9f9; background: white !important; }
.tooltip .popover-inner {
  background: #f5eeff; color: black; border: #753bbd 2px solid;
  width: 750px; padding: 24px; border-radius: 5px; margin-left: 1px;
}
.tooltip.popover .popover-arrow { border-color: white !important; }
.tooltip::before { display: unset; width: 0; height: 0; content: unset; }
.text-blue { color: #00f; }
.text-blue.link { cursor: pointer; }
.close { display: flex; justify-content: flex-end; margin-bottom: 10px; }
.download-image { display: flex; justify-content: space-between; }
</style>
